import { StartClient } from "@tanstack/react-start/client";
import * as Effect from "effect/Effect";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { initializeI18n } from "./i18n/runtime";

const hydrate = () => {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    );
  });
};

await Effect.runPromiseExit(initializeI18n);
hydrate();
